<template>
  <div class="mysymptoms-main-container">
    <v-container>
      <h1>User Details</h1>

      <!--      a draggable help dialogue -->
      <v-dialog
          v-model="showHelpDialog"
          max-width="500"
          overlay="false"
          content-class="draggable-help-dialog"
      >
        <v-card>
          <v-card-title class="headline" @mousedown="startDrag" style="cursor: move;">User Details Help</v-card-title>
          <v-card-text>
            <ul>
              <li><strong>Username:</strong> The user's login name.</li>
              <li><strong>First/Last Name:</strong> The user’s personal name. Will be empty if user has not shared
                their diary with a clinician.
              </li>
              <li><strong>Email:</strong> The user’s registered email address. Will be empty if user has not shared heir
                diary with a clinician.
              </li>
              <li><strong>Clinician:</strong> Indicates if the user is a clinician.</li>
              <li><strong>Registration Date:</strong> When the user first created their account.</li>
              <li><strong>Authorities:</strong> User's roles or permissions. Either:</li>
              <ul>
                <li><strong>USER</strong>: a mobile diary user</li>
                <li><strong>CLINICIAN</strong>: a clinician user</li>
                <li><strong>SUPPORT</strong>: a Skygazer Labs support staff</li>
                <li><strong>SYS_ADMIN</strong>: a Skygazer Labs system administrator</li>
              </ul>
              <li>
                <strong>Agents:</strong> the model number of the devices over the last 1000 diary events and outcomes
                 plus the one they originally created the account with, sorted in alphabetical order.
              </li>
              <li><strong>Send Password Reset:</strong> Triggers a password reset email to the registered email
                address. If there is no email address you may enter one, but you must
                verify that the email address does indeed belong to the user. How .. TODO</li>
              <li><strong>Open Patient Diary:</strong> Opens the patient's diary in a new tab.</li>
            </ul>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="showHelpDialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
          v-model="showHelpDialog2"
          max-width="600"
          overlay="false"
          content-class="draggable-help-dialog2"
      >
        <v-card>
          <v-card-title class="headline" @mousedown="startDrag2" style="cursor: move;">Products Help</v-card-title>
          <v-card-text>
            The list of subscription products this user is entitled to:
            <ul>
              <li><strong>Purchased Date</strong>: The date this subscription started</li>
              <li><strong>Expires Date</strong>: The current expiry date for this subscription. Each time the
                subscription
                renews this will be updated.
              </li>

              <li><strong>Product:</strong> will be one of the following</li>
              <ul>
                <li><strong>com.sglabs.mysymptoms.sub.premium</strong>: For users who have taken out a (paid)
                  subscription
                  to iOS or Android.
                  Could be 1m, 6m or 12m. They all with with a 7 day free trial.
                </li>
                <li><strong>com.sglabs.mysymptoms.sub.freemium</strong>: For Android users without a subscription
                  (either they dismiss the paywall, or their subscription lapses). Rhey revert to feature limited
                  version of the app, which they can use indefinitely.
                </li>
                <li><strong>com.sglabs.mysymptoms.free.2wtrial</strong>: For iOS users without out a subscription
                  (either they dismiss the paywall, or their subscription lapses). They revert to a limited feature
                  version of the app for two weeks. After two weeks, if they
                  try to use the app they are presented with the paywall. This option used to be available on Android
                  also before we introduced Freemium.
                </li>
                <li><strong>com.sglabs.mysymptoms.paid.legacy</strong>: For users who previously paid for the app
                  with it was available for a one off payment. They are now
                  entitled to a fully featured subscription indefinitely.
                </li>
                <li><strong>com.sglabs.mysymptoms.free.legacy</strong>: For users who previously used the free app. They
                  are now entitled to ... TBC
                </li>
                <li><strong>com.sglabs.mysymptoms.free.patient</strong>: For users who are patients of one of our
                  clinicians. The are entitled to use a limited feature version of the app for free.
                </li>
              </ul>
              <li><strong>Description:</strong> Will be one of the following</li>
              <ul>
                <li><strong>Premium (free trial)</strong>: when in the 7 day free trial of 1m, 6m or 12m premium
                  subscription.
                </li>
                <li><strong>Premium</strong>: When beyond the 7 day free trial of 1m, 6m or 12m premium subscription.
                </li>
                <li><strong>Free version</strong>: for the freemium version</li>
                <li><strong>Paid (legacy - no expiry)</strong>: for paid legacy version</li>
                <li><strong>Free (legacy - no expiry)</strong>: for free legacy version</li>
                <li><strong>Free 2-week limited trial/Free 2 week trial/Free limited trial</strong>: for the free
                  2wk trial. TODO - why are there three versions?
                </li>
                <li><strong>Clinician patient</strong>: for the free patient version</li>
              </ul>
              <li><Strong>Period:</Strong></li>
              <ul>
                <li><strong>1 week </strong> when in the free period of the premium paid subscriptions</li>
                <li><strong>1/6/12 months (Play Store) or 1 year (App Store)</strong> when in the paid period the
                  premium
                  paid subscriptions
                </li>
                <li><strong>2 weeks</strong> for the 2 week free trial</li>
                <li><strong>Unlimited</strong>: for the freemium, paid legacy and free legacy versions</li>
                <li><strong>Limited (patient)</strong>: for the clinician patient version</li>
              </ul>
              <li><Strong>Store</Strong>: will be either <strong>App Store</strong>, <strong>Play Store</strong> or
                <strong>Clinic</strong> depending on the where the subscription originated.
              </li>
              <li><Strong>State:</Strong></li>
              <ul>
                <li>Subscribed, Expired, BillingRetryPeriod, Revoked, GracePeriod are Google Play Billing states.
                  See <a href="https://developer.android.com/google/play/billing/lifecycle/subscriptions"
                         target="_blank">here
                  </a>
                  for more details.
                </li>
                <li>SUBSCRIPTION_STATE_EXPIRED, SUBSCRIPTION_STATE_ACTIVE, SUBSCRIPTION_STATE_CANCELED,
                  SUBSCRIPTION_STATE_ON_HOLD, SUBSCRIPTION_STATE_IN_GRACE_PERIOD are App Store states. See <a
                      href="https://developer.apple.com/documentation/storekit/product/subscriptioninfo/renewalstate"
                      target="_blank">here
                  </a> for more details.
                </li>
              </ul>
              <li><strong>Latest Order Id:</strong> for Android users this is the Play Store order id for the
                subscription, e.g GPA.3348-6354-9727-67323..1. All renewals will have the same order id with the
                final digit incremented. Click on the link to take you to the corresponding order page in the
                Google Play Console.
              </li>
              <li><strong>Purchase Token:</strong> the Play Store Purchase token. Used primarily for debugging. It
                is used to tie together Play Store subscription updates with our database records.
              </li>
              <li><strong>Created Date</strong>: This is used primarily for debugging. It is the date this database
                record was created. It is typically shortly after the Purchased Date. If it is considerably longer,
                it could indicate problems with sync.
              </li>
            </ul>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="showHelpDialog2 = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-row>
        <!--        <v-col cols="12" md="8" offset-md="2">-->
        <v-col cols="12" md="8">
          <!--          <v-card class="mx-auto my-5" max-width="600">-->
          <v-card class="my-4" max-width="600">
            <v-card-title>
              <h3>User</h3>
              <v-spacer></v-spacer>
              <!--              <v-spacer />-->
              <v-btn right icon small @click="showHelpDialog = true" style="color: #1976d2;">
                <v-icon right>help</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-text-field
                  name="username"
                  label="Username"
                  v-model="username"
                  readonly
              ></v-text-field>
              <v-text-field
                  name="firstname"
                  label="First Name"
                  v-model="firstName"
                  readonly
              ></v-text-field>
              <v-text-field
                  name="lastname"
                  label="Last Name"
                  v-model="lastName"
                  readonly
              ></v-text-field>
              <v-text-field
                  name="email"
                  label="Email"
                  v-model="email"
                  readonly
              ></v-text-field>
              <v-checkbox
                  v-model="isClinician"
                  :label="`Clinician`"
                  readonly
              ></v-checkbox>
              <v-text-field
                  name="registration_date"
                  label="Registration Date"
                  v-model="registrationDate"
                  readonly
              ></v-text-field>
              <v-text-field
                  name="authorities"
                  label="Authorities"
                  v-model="authorities"
                  readonly
              ></v-text-field>
              <v-text-field
                  name="userAgents"
                  label="Agents"
                  v-model="userAgents"
                  readonly
              ></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-btn
                  color="primary"
                  class="mt-3"
                  @click="showResetDialog = true"
              >
                Send Password Reset
              </v-btn>
              <v-btn
                  color="primary"
                  class="mt-3"
                  :to="{ name: 'patient_diary', params: { patientUsername: username } }"
              >
                Open Patient Diary
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
<!--        default the resetEmail to the currently held email address on the open event-->
        <v-dialog v-model="showResetDialog" max-width="500">
          <v-card>
            <v-card-title>Send Password Reset</v-card-title>
            <v-card-text>
              <v-text-field
                  v-model="resetEmail"
                  label="Email Address"
                  type="email"
                  :readonly="resetEmailReadonly"
              ></v-text-field>
              <v-checkbox
                  v-model="identityVerified"
                  label="I have verified the user's identity"
                  :disabled="resetEmail === email"
              ></v-checkbox>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="showResetDialog = false">Cancel</v-btn>
              <v-btn color="primary" @click="sendPasswordReset" :disabled="resetEmail !== email && !identityVerified">Send</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-col cols="12" md="8" offset-md="2">
          <v-card class="rounded-card">
            <v-card-title>
              <h3>Products</h3>
              <v-spacer></v-spacer>
              <!--              <v-spacer />-->
              <v-btn right icon small @click="showHelpDialog2 = true" style="color: #1976d2;">
                <v-icon right>help</v-icon>
              </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-data-table
                :headers="productHeaders"
                :items="products"
                no-data-text="No products"
                class="elevation-1"
                v-bind:pagination.sync="pagination"
            >
              <template v-slot:items="props">
                <td>{{ formatDate(props.item.purchasedDate) }}</td>
                <td>{{ formatDate(props.item.expiresDate) }}</td>
                <td>{{ props.item.productId }}</td>
                <td>{{ props.item.planId }}</td>
                <td>{{ props.item.description }}</td>
                <td>{{ props.item.period }}</td>
                <td>{{ props.item.store }}</td>
                <td>{{ props.item.state }}</td>
                <td>
                  <a
                      :href="`https://play.google.com/console/u/1/developers/5396866449560004276/orders/${props.item.latestOrderId}`"
                      target="_blank"
                      rel="noopener noreferrer"
                  >
                    {{ props.item.latestOrderId }}
                  </a>
                </td>
                <td>{{ props.item.purchaseToken }}</td>
                <td>{{ formatDate(props.item.createdAt) }}</td>
                <!--                <td class="text-xs-right">{{ formatPaymentPrice(props.item.saleGross, props.item.currency) }}</td>-->
                <!--                <td class="text-xs-right"><a :href="props.item.receiptUrl" target="_blank">View Invoice</a></td>-->
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>

import {defineComponent} from "@vue/composition-api";
// import {ScatterChart} from "vue-chart-3";
// import DiaryV2Component from "@/components/DiaryV2Component.vue";
import VError from "verror";
import Logger from '../utils/logger-utils'
import AccountService from '../utils/account-service'
import ProductService from '../utils/product-service'
import moment from 'moment'
import _ from "lodash";

export default defineComponent({
  name: "UserDetails",
  props: ['username'],
  components: {},

  data() {
    return {
      resetEmailReadonly: false,
      firstName: '',
      lastName: '',
      email: '',
      authorities: '',
      proucts: '',
      registrationDate: '',
      isClinician: '',
      products: [],
      userAgents: [], // devices used by the user
      pagination: {'sortBy': 'purchasedDateSortable', 'descending': true, 'rowsPerPage': 50},
      productHeaders: [
        {text: 'Purchased Date', align: 'left', sortable: true, value: 'purchasedDate'},
        {text: 'Expires Date', align: 'left', sortable: true, value: 'expiresDate'},
        {text: 'Product', value: 'productId', sortable: false},
        {text: 'Plan', value: 'planId', sortable: false},
        {text: 'Description', value: 'description', sortable: false},
        {text: 'Period', value: 'period', sortable: false},
        {text: 'Store', value: 'store', sortable: false},
        {text: 'State', value: 'state', sortable: false},
        {text: 'Latest Order Id', value: 'latestOrderId', sortable: false},
        {text: 'Purchase Token', value: 'purchaseToken', sortable: false},
        {text: 'Created Date', align: 'left', sortable: true, value: 'createdAt'},
        // {text: 'Amount', value: 'amount', sortable: false},
        // {text: 'View Invoice', value: 'view', sortable: false},
      ],
      showResetDialog: false,
      resetEmail: '',
      identityVerified: false,
      showHelpDialog: false,
      showHelpDialog2: false,
      dragOffset: {x: 0, y: 0},
      isDragging: false,
      dragOffset2: {x: 0, y: 0},
      isDragging2: false,
    }
  },

  mounted() {
    try {

      const tz = moment.tz.guess(true);

      if (typeof this.username === 'undefined') {
        Logger.error(new VError("username undefined"), {})
      } else {


        // // see if the patient's real name is set in the database, if not, look to see if we're storing it in local
        // // storage
        AccountService.getUsersAccountInfo(this.username).then(res => {

          this.firstName = res.data.firstName
          this.lastName = res.data.lastName
          this.email = res.data.email
          // this.registrationDate = moment(res.data.registrationDate).format('DD MMM YYYY HH:mm');
          this.registrationDate = this.formatDate(moment(res.data.registrationDate))
          this.authorities = res.data.authorities.join(', ')
        }).catch(err => {
          Logger.error(new VError(err, `failed to get user detail ${this.username}`), {})
        })

        ProductService.getProductsForUser(this.username).then(res => {

          const products_tmp = _.map(res.data, product => {
            const x = {
              purchasedDate: moment.tz(product.purchasedDate, tz),
              expiresDate: moment.tz(product.expiresDate, tz),
              createdAt: moment.tz(product.createdAt, tz),
              purchasedDateSortable: moment.tz(product.purchasedDate, tz).valueOf(),
              expiresDateSortable: moment.tz(product.expiresDate, tz).valueOf(),
              createdAtSortable: moment.tz(product.createdAt, tz).valueOf(),
              productId: product.productId,
              planId: product.planId,
              description: product.description,
              period: product.period,
              store: product.store,
              latestOrderId: product.latestOrderId,
              purchaseToken: product.purchaseToken,
              state: product.state,
            }
            return x
          })
          this.products = products_tmp
        }).catch(err => {
          Logger.error(new VError(err, `failed to get products for ${this.username}`), {})
        })

        AccountService.getUsersAgents(this.username).then(res => {

          const x = res.data.join(', ')
          this.userAgents = x
        }).catch(err => {
          Logger.error(new VError(err, `failed to get products for ${this.username}`), {})
        })
      }
    } catch (e) {
      Logger.error(new VError(e, `failed to get products for ${this.username}`), {})
    }
  },

  methods: {
    formatDate(date) {
      const formattedDate = (date instanceof moment) ? date.format("DD/MM/YY HH:MM") : ""
      return formattedDate
    },
    sendPasswordReset() {
      AccountService.resetPasswordRequestPrivate(this.username, this.resetEmail)
          .then(() => {
            Logger.debug(`Password reset email sent to ${this.resetEmail} for ${this.username}`);
            this.showResetDialog = false;
          })
          .catch(err => {
            Logger.error(new VError(err, `Failed to send password reset to ${this.resetEmail}`));
          });
    },
    startDrag(event) {
      const dialog = document.querySelector('.draggable-help-dialog');
      if (!dialog) return;
      const rect = dialog.getBoundingClientRect();

      this.dragOffset.x = event.clientX - rect.left;
      this.dragOffset.y = event.clientY - rect.top;

      this.isDragging = true;

      const onMouseMove = (e) => {
        if (!this.isDragging) return;
        dialog.style.position = 'fixed';
        dialog.style.margin = 0;
        dialog.style.left = `${e.clientX - this.dragOffset.x}px`;
        dialog.style.top = `${e.clientY - this.dragOffset.y}px`;
      };

      const onMouseUp = () => {
        this.isDragging = false;
        window.removeEventListener('mousemove', onMouseMove);
        window.removeEventListener('mouseup', onMouseUp);
      };

      window.addEventListener('mousemove', onMouseMove);
      window.addEventListener('mouseup', onMouseUp);
    },
    startDrag2(event) {
      const dialog = document.querySelector('.draggable-help-dialog2');
      if (!dialog) return;
      const rect = dialog.getBoundingClientRect();

      this.dragOffset2.x = event.clientX - rect.left;
      this.dragOffset2.y = event.clientY - rect.top;

      this.isDragging2 = true;

      const onMouseMove = (e) => {
        if (!this.isDragging2) return;
        dialog.style.position = 'fixed';
        dialog.style.margin = 0;
        dialog.style.left = `${e.clientX - this.dragOffset2.x}px`;
        dialog.style.top = `${e.clientY - this.dragOffset2.y}px`;
      };

      const onMouseUp = () => {
        this.isDragging2 = false;
        window.removeEventListener('mousemove', onMouseMove);
        window.removeEventListener('mouseup', onMouseUp);
      };

      window.addEventListener('mousemove', onMouseMove);
      window.addEventListener('mouseup', onMouseUp);
    }
  },
  watch: {
    showResetDialog(val) {
      if (val) {
        this.resetEmail = this.email;
        this.resetEmailReadonly = !!this.resetEmail;
      }
    }
  },
})

</script>
<style scoped>
.draggable-help-dialog {
  background-color: rgba(255, 255, 255, 0.95);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  position: fixed;
  z-index: 999;
}

.draggable-help-dialog2 {
  background-color: rgba(255, 255, 255, 0.95);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  position: fixed;
  z-index: 999;
}
</style>
